export const Repos2NameMapping: { [key: string]: string } = {
  "enterprise": "Enterprise",
  "standard": "Standard",
  "community360": "Community 360",
  "postgres_distributed": "Postgres Distributed 5",
  "postgres_distributed_4": "Postgres Distributed 4",
  "postgres_extended": "Postgres Extended (legacy 2ndQuadrant packages)"
}